module.exports = __webpack_public_path__ + "media/images/bg/right_bg@2x-757f36b3fedd90d4bce10698bbffe2e3.jpg";